var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aplayer',{attrs:{"id":"aplayer-main","theme":"#52194d","repeat":"no-repeat","music":_vm.songQueue[0],"list":_vm.songQueue,"listFolded":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }